document.addEventListener("DOMContentLoaded", function() {
  handleNestedSelection();
  initCrossSellingPopup();
});

function handleNestedSelection() {
  const form = document.querySelector('form.main-product-form');
  if (!form) return;

  let parentInput = form.querySelector('input[name="nested_ids"]');
  if (!parentInput) {
    parentInput = document.createElement('input');
    parentInput.type = 'hidden';
    parentInput.name = 'nested_ids';
    form.appendChild(parentInput);
  }

  const wrappers = document.querySelectorAll('.wim-nested-grid-wrapper');

  wrappers.forEach(wrapper => {

    const detailBtn = wrapper.querySelector('.wim-nested-btn');

    if (detailBtn) {
      detailBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        openNestedDetailPopup(wrapper, 'nested');
      });
    }

    const items = wrapper.querySelectorAll('.wim-nested-item');

    items.forEach(item => {
      item.addEventListener('click', (e) => {
        if (e.target.closest('.nested-remove')) return;

        const variantId = item.dataset.variantId;
        if (!variantId) return;

        items.forEach(sibling => {
          if (sibling !== item && sibling.classList.contains('selected')) {
            sibling.classList.remove('selected');
            const removeBtn = sibling.querySelector('.nested-remove');
            if (removeBtn) removeBtn.remove();
          }
        });

        const isSelected = item.classList.contains('selected');

        if (isSelected) {
          item.classList.remove('selected');
          const btn = item.querySelector('.nested-remove');
          if (btn) btn.remove();
        } else {
          item.classList.add('selected');

          const closeBtn = document.createElement('button');
          closeBtn.type = 'button';
          closeBtn.className = 'nested-remove';
          closeBtn.innerHTML = `
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.8835 5.88353C6.13734 5.62969 6.54889 5.62969 6.80273 5.88353L12 11.0808L17.1972 5.88353C17.451 5.62969 17.8626 5.62969 18.1164 5.88353C18.3703 6.13737 18.3703 6.54892 18.1164 6.80277L12.9192 12L18.1164 17.1972C18.3703 17.4511 18.3703 17.8626 18.1164 18.1165C17.8626 18.3703 17.451 18.3703 17.1972 18.1165L12 12.9192L6.80273 18.1165C6.54889 18.3703 6.13734 18.3703 5.8835 18.1165C5.62966 17.8626 5.62966 17.4511 5.8835 17.1972L11.0807 12L5.8835 6.80277C5.62966 6.54892 5.62966 6.13737 5.8835 5.88353Z" fill="#02383E"/>
          </svg>`;
          closeBtn.addEventListener('click', (ev) => {
            ev.stopPropagation();
            item.classList.remove('selected');
            closeBtn.remove();
             syncNestedIDs();
          });
          item.appendChild(closeBtn);
        }
        syncNestedIDs(); 
      });
    });
  });

  // --- MINI CAROUSEL LOGIC ---
   if (window.innerWidth >= 1024) {
    const grids = document.querySelectorAll('.wim-nested-grid');
    grids.forEach(grid => {
      const items = Array.from(grid.querySelectorAll('.wim-nested-item'));
      if (items.length <= 4) return;

      const wrapper = document.createElement('div');
      wrapper.className = 'wim-carousel-wrapper';
      grid.parentNode.insertBefore(wrapper, grid);
      wrapper.appendChild(grid);

      const svgArrow = `
        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 24 24">
          <path fill-rule="evenodd" d="M13.46 5.19a.65.65 0 0 1 .919.92l-5.54 5.54 5.54 5.54a.65.65 0 0 1-.92.92L7 11.65l6.46-6.46Z" clip-rule="evenodd"></path>
        </svg>
      `;

      const btnPrev = document.createElement('button');
      const btnNext = document.createElement('button');
      btnPrev.className = 'wim-carousel-arrow wim-carousel-prev';
      btnNext.className = 'wim-carousel-arrow wim-carousel-next';
      btnPrev.innerHTML = svgArrow;
      btnNext.innerHTML = svgArrow;
      wrapper.appendChild(btnPrev);
      wrapper.appendChild(btnNext);

      btnPrev.disabled = true;

      const updateButtons = () => {
        const maxScroll = grid.scrollWidth - grid.clientWidth - 2;
        btnPrev.disabled = grid.scrollLeft <= 0;
        btnNext.disabled = grid.scrollLeft >= maxScroll;
      };

      const getCurrentIndex = () => {
        const scrollLeft = grid.scrollLeft;
        let closestIndex = 0;
        let minDistance = Infinity;
        items.forEach((item, i) => {
          const itemCenter = item.offsetLeft + item.offsetWidth / 2;
          const distance = Math.abs(itemCenter - (scrollLeft + grid.clientWidth / 2));
          if (distance < minDistance) {
            minDistance = distance;
            closestIndex = i;
          }
        });
        return closestIndex;
      };

      const animateScroll = (from, to, duration = 100) => {
        const start = performance.now();
        const step = (now) => {
          const progress = Math.min((now - start) / duration, 1);
          grid.scrollLeft = from + (to - from) * progress;
          if (progress < 1) requestAnimationFrame(step);
          else updateButtons();
        };
        requestAnimationFrame(step);
      };

      const scrollToItem = (indexTarget) => {
        if (indexTarget < 0 || indexTarget >= items.length) return;
        const item = items[indexTarget];
        const offset = item.offsetWidth + 16;
        const direction = indexTarget > getCurrentIndex() ? 1 : -1;
        const targetScroll = grid.scrollLeft + (direction * offset);
        animateScroll(grid.scrollLeft, targetScroll, 100);
      };

      btnPrev.addEventListener('click', () => {
        const current = getCurrentIndex();
        scrollToItem(current - 1);
      });

      btnNext.addEventListener('click', () => {
        const current = getCurrentIndex();
        scrollToItem(current + 1);
      });

      grid.addEventListener('scroll', updateButtons);
    });
   }
}


function initCrossSellingPopup() {

  const popup = document.querySelector('.wim-crosselling-popup');
  if (!popup) return;

  if (popup.parentElement !== document.body) {
    document.body.appendChild(popup);
  } 
  const popupDetailButtons = popup.querySelectorAll('.wim-nested-btn');

  popupDetailButtons.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const grid = btn.closest('.wim-crosselling-grid');
      if (!grid) return;

      openNestedDetailPopup(grid,'crosselling');
    });
  });
  const form = document.querySelector('form.main-product-form');
  const originalBtn = document.querySelector('.product__blocks button.product-form__submit');
  if (!form || !originalBtn) return;

  if (document.querySelector('.product-form__submit--clone')) return;


  const clonedBtn = originalBtn.cloneNode(true);
  let popupOpenedBy = null; 
  clonedBtn.classList.add('product-form__submit--clone');
  clonedBtn.style.display = '';
  originalBtn.style.display = 'none';
  originalBtn.classList.add('product-form__submit--hidden');
  originalBtn.parentNode.insertBefore(clonedBtn, originalBtn);

  // --- 3. Elementos del popup ---
  const closeBtn = popup.querySelector('.wim-crosselling-close');
  const overlay = popup.querySelector('.wim-crosselling-overlay');
  const confirmBtn = popup.querySelector('.wim-crosselling-confirm');
  const crossItems = popup.querySelectorAll('.wim-crosselling-item');

  const openPopup = () => {
    popup.setAttribute('aria-hidden', 'false');
    popup.style.display = 'flex';
    document.body.classList.add('no-scroll');

    const priceTarget = popup.querySelector('.wim-crosselling-header .info-product .price');
    const realPrice = document.querySelector('.product__info-wrapper .f-price__regular .f-price-item');

    if (priceTarget && realPrice) {
      priceTarget.innerHTML = realPrice.innerHTML.trim();
    }

    updateCrossSellingAddonsPreview();
  };

  const closePopup = () => {
    popup.setAttribute('aria-hidden', 'true');
    popup.style.display = 'none';
    document.body.classList.remove('no-scroll');
  };

  clonedBtn.addEventListener('click', (e) => {
    e.preventDefault();
    popupOpenedBy = 'main';
    openPopup();
  });

  [closeBtn, overlay].forEach(el => {
    if (el) {
      el.addEventListener('click', () => {
        closePopup();
      });
    }
  });

  const stickyOriginalBtn = document.querySelector('.sticky-atc-bar__form button.product-form__submit');

  let clonedStickyBtn;
  if (stickyOriginalBtn && !document.querySelector('.product-form__submit--clone-sticky')) {

    clonedStickyBtn = stickyOriginalBtn.cloneNode(true);
    clonedStickyBtn.classList.add('product-form__submit--clone-sticky');
    clonedStickyBtn.style.display = '';

    stickyOriginalBtn.style.display = 'none';
    stickyOriginalBtn.classList.add('product-form__submit--hidden-sticky');

    stickyOriginalBtn.parentNode.insertBefore(clonedStickyBtn, stickyOriginalBtn);

    clonedStickyBtn.addEventListener('click', (e) => {
      e.preventDefault();
      popupOpenedBy = 'sticky';
      openPopup();
    });
  }
  
  crossItems.forEach(item => {
    item.addEventListener('click', (e) => {
      if (e.target.closest('.nested-remove')) return;

      const variantId = item.dataset.variantId;
      if (!variantId) return;
      const grid = item.closest('.wim-crosselling-grid');
      if (!grid) return;


      const targetForm = document.querySelector('.product__block form.main-product-form');
      if (!targetForm) return;

      let parentInput = targetForm.querySelector('input[name="nested_ids"]');
      if (!parentInput) {
        parentInput = document.createElement('input');
        parentInput.type = 'hidden';
        parentInput.name = 'nested_ids';
        targetForm.appendChild(parentInput);
      }


      grid.querySelectorAll('.wim-crosselling-item.selected').forEach(sel => {
        sel.classList.remove('selected');
        const removeBtn = sel.querySelector('.nested-remove');
        if (removeBtn) removeBtn.remove();
      });

      item.classList.add('selected');

      if (!item.querySelector('.nested-remove')) {
        const closeBtn = document.createElement('button');
        closeBtn.type = 'button';
        closeBtn.className = 'nested-remove';
        closeBtn.innerHTML = `
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.8835 5.88353C6.13734 5.62969 6.54889 5.62969 6.80273 5.88353L12 11.0808L17.1972 5.88353C17.451 5.62969 17.8626 5.62969 18.1164 5.88353C18.3703 6.13737 18.3703 6.54892 18.1164 6.80277L12.9192 12L18.1164 17.1972C18.3703 17.4511 18.3703 17.8626 18.1164 18.1165C17.8626 18.3703 17.451 18.3703 17.1972 18.1165L12 12.9192L6.80273 18.1165C6.54889 18.3703 6.13734 18.3703 5.8835 18.1165C5.62966 17.8626 5.62966 17.4511 5.8835 17.1972L11.0807 12L5.8835 6.80277C5.62966 6.54892 5.62966 6.13737 5.8835 5.88353Z" fill="#02383E"/>
          </svg>`;
        closeBtn.addEventListener('click', (ev) => {
          ev.stopPropagation();
          item.classList.remove('selected');
          closeBtn.remove();

          syncNestedIDs();
          updateCrossSellingAddonsPreview();
        });
        item.appendChild(closeBtn);
      }
      syncNestedIDs();
      updateCrossSellingAddonsPreview();
    });
  });


  if (confirmBtn) {
    confirmBtn.addEventListener('click', (e) => {
      e.preventDefault();

      closePopup();
    if (popupOpenedBy === 'sticky' && stickyOriginalBtn) {
      stickyOriginalBtn.click();
    } else {
      originalBtn.click();
    }

    popupOpenedBy = null;
    });
  }

  // --- 7. carousel ----
  if (window.innerWidth >= 1024) {
    const initMiniCarousel = () => {
      const carousels = popup.querySelectorAll('.wim-crosselling-items');

      carousels.forEach(carousel => {
        const items = Array.from(carousel.querySelectorAll('.wim-crosselling-item'));
        if (items.length <= 4) return;

        const wrapper = document.createElement('div');
        wrapper.className = 'wim-carousel-wrapper';
        carousel.parentNode.insertBefore(wrapper, carousel);
        wrapper.appendChild(carousel);

        const svgArrow = `
          <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 24 24" class="ArrowRight__IconArrowRight-sc-6c7b5929-0 hTvhXC"><path fill-rule="evenodd" d="M9.54 18.46a.65.65 0 0 1 0-.92L15.08 12 9.54 6.46a.65.65 0 0 1 .92-.92L16.92 12l-6.46 6.46a.65.65 0 0 1-.92 0Z" clip-rule="evenodd"></path></svg>
        `;

        const btnPrev = document.createElement('button');
        const btnNext = document.createElement('button');
        btnPrev.className = 'wim-carousel-arrow wim-carousel-prev';
        btnNext.className = 'wim-carousel-arrow wim-carousel-next';
        btnPrev.innerHTML = svgArrow;
        btnNext.innerHTML = svgArrow;
        wrapper.appendChild(btnPrev);
        wrapper.appendChild(btnNext);

        btnPrev.disabled = true;

        const updateButtons = () => {
          const maxScroll = carousel.scrollWidth - carousel.clientWidth - 2;
          btnPrev.disabled = carousel.scrollLeft <= 0;
          btnNext.disabled = carousel.scrollLeft >= maxScroll;
        };

        const getCurrentIndex = () => {
          const scrollLeft = carousel.scrollLeft;
          let closestIndex = 0;
          let minDistance = Infinity;
          items.forEach((item, i) => {
            const itemCenter = item.offsetLeft + item.offsetWidth / 2;
            const distance = Math.abs(itemCenter - (scrollLeft + carousel.clientWidth / 2));
            if (distance < minDistance) {
              minDistance = distance;
              closestIndex = i;
            }
          });
          return closestIndex;
        };

        const animateScroll = (from, to, duration = 100) => {
          const start = performance.now();
          const step = (now) => {
            const progress = Math.min((now - start) / duration, 1);
            carousel.scrollLeft = from + (to - from) * progress;
            if (progress < 1) requestAnimationFrame(step);
            else updateButtons();
          };
          requestAnimationFrame(step);
        };

        const scrollToItem = (indexTarget) => {
          if (indexTarget < 0 || indexTarget >= items.length) return;
          const item = items[indexTarget];
          const offset = item.offsetWidth + 16;
          const direction = indexTarget > getCurrentIndex() ? 1 : -1;
          const targetScroll = carousel.scrollLeft + (direction * offset);
          animateScroll(carousel.scrollLeft, targetScroll, 100);
        };

        btnPrev.addEventListener('click', () => {
          const current = getCurrentIndex();
          scrollToItem(current - 1);
        });

        btnNext.addEventListener('click', () => {
          const current = getCurrentIndex();
          scrollToItem(current + 1);
        });

        carousel.addEventListener('scroll', updateButtons);
      });
    };
    
    initMiniCarousel();
  }
}

function syncNestedIDs() {
  const form = document.querySelector('form.main-product-form');
  if (!form) return;

  let parentInput = form.querySelector('input[name="nested_ids"]');
  if (!parentInput) {
    parentInput = document.createElement('input');
    parentInput.type = 'hidden';
    parentInput.name = 'nested_ids';
    form.appendChild(parentInput);
  }

  const selected = [
    ...document.querySelectorAll('.wim-nested-item.selected'),
    ...document.querySelectorAll('.wim-crosselling-item.selected')
  ];

  const ids = selected
    .map(el => el.dataset.variantId)
    .filter(Boolean);


  parentInput.value = ids.join(',');
}

function updateCrossSellingAddonsPreview() {
  const MAX_VISIBLE_IMAGES = 3;

  const popup = document.querySelector('.wim-crosselling-popup');
  if (!popup) return;

  const addonsTarget = popup.querySelector('.wim-crosselling-header .info-addons');
  if (!addonsTarget) return;

  addonsTarget.innerHTML = '';

  const hiddenInput = document.querySelector('form.main-product-form input[name="nested_ids"]');
  if (!hiddenInput) return;

  const ids = hiddenInput.value.split(',').filter(Boolean);

  if (ids.length === 0) return;

  ids.forEach((id, index) => {
    if (index >= MAX_VISIBLE_IMAGES) return;

    const imgEl = document.querySelector(`div[data-variant-id="${id}"] img`);
    if (!imgEl) return;

    const item = document.createElement('div');
    item.className = 'item';

    const cloneImg = document.createElement('img');
    cloneImg.src = imgEl.src;
    cloneImg.alt = imgEl.alt || '';

    item.appendChild(cloneImg);
    addonsTarget.appendChild(item);
  });

  const extra = ids.length - MAX_VISIBLE_IMAGES;
  if (extra > 0) {
    const counterItem = document.createElement('div');
    counterItem.className = 'item counter';
    counterItem.textContent = `+${extra}`;
    addonsTarget.appendChild(counterItem);
  }
}
function openNestedDetailPopup(wrapper, mode = "nested") {
  const config = {
    nested: {
      item: ".wim-nested-item",
      title: ".wim-nested-title",
      price: ".wim-nested-price",
      img: "img",
      desc: "template.wim-nested-description"
    },
    crosselling: {
      item: ".wim-crosselling-item",
      title: ".wim-crosselling-title",
      price: ".wim-crosselling-price",
      img: "img",
      desc: "template.wim-crosselling-description"
    }
  };

  const selectors = config[mode];

  let popup = document.querySelector('.wim-nested-detail-popup');

  if (!popup) {
    const template = document.getElementById('wim-nested-detail-popup-template');
    if (!template) {
      console.error("Template #wim-nested-detail-popup-template no encontrado");
      return;
    }

    popup = template.content.firstElementChild.cloneNode(true);
    document.body.appendChild(popup);
  }

  const overlay = popup.querySelector('.wim-nested-detail-overlay');
  const closeBtn = popup.querySelector('.wim-nested-detail-close');
  const listBox = popup.querySelector('.wim-nested-detail-list');
  const titleBox = popup.querySelector('#wim-nested-detail-title');

  let popupTitle = "";

  if (mode == "nested") {
    const headerTitle = wrapper.querySelector('.wim-nested-header .title');
    popupTitle = headerTitle?.innerText?.trim() || "";
  }

  if (mode == "crosselling") {
    const collectionTitle = wrapper.querySelector('.wim-crosselling-collection-title .title');
    popupTitle = collectionTitle?.innerText?.trim() || "";
  }


  titleBox.innerText = popupTitle;
  listBox.innerHTML = '';

  const items = wrapper.querySelectorAll(selectors.item);
  
  items.forEach(item => {

    const img = item.querySelector(selectors.img);
    const title = item.querySelector(selectors.title)?.innerText.trim() || '';
    const price = item.querySelector(selectors.price)?.innerHTML || '';
    const tpl = item.querySelector(selectors.desc);

    const isSelected = item.classList.contains('selected');

    const block = document.createElement('div');
    block.className = 'wim-nested-detail-item';
    if (isSelected) block.classList.add('is-selected');

    // Procesar imagen con width=500
    let cleanSrc = '';
    if (img) {
      cleanSrc = img.src.replace(/([&?])width=\d+/g, '');
      cleanSrc += cleanSrc.includes('?') ? '&width=500' : '?width=500';
    }

    block.innerHTML = `
      <div class="wim-nested-detail-img">
        ${img ? `<img src="${cleanSrc}" alt="">` : ''}
      </div>

      <div class="wim-nested-detail-title">${title}</div>

      <div class="wim-nested-detail-price">${price}</div>

      <div class="wim-nested-detail-description">
        ${tpl ? tpl.innerHTML : ''}
      </div>

      <button class="wim-nested-detail-select btn btn--primary" data-variant-id="${item.dataset.variantId}">
        <span class="btn__text">${theme.translates.webimpacto.nested.select_text}</span>
      </button>
    `;

    listBox.appendChild(block);

    // ------------------------------------------
    // Botón remove si está seleccionado
    // ------------------------------------------
    if (isSelected) {
      const removeBtn = document.createElement('button');
      removeBtn.className = 'wim-nested-detail-remove nested-remove';
      removeBtn.type = 'button';

      removeBtn.innerHTML = `
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M5.8835 5.88353C6.13734 5.62969 6.54889 5.62969 6.80273 5.88353L12 11.0808L17.1972 5.88353C17.451 5.62969 17.8626 5.62969 18.1164 5.88353C18.3703 6.13737 18.3703 6.54892 18.1164 6.80277L12.9192 12L18.1164 17.1972C18.3703 17.4511 18.3703 17.8626 18.1164 18.1165C17.8626 18.3703 17.451 18.3703 17.1972 18.1165L12 12.9192L6.80273 18.1165C6.54889 18.3703 6.13734 18.3703 5.8835 18.1165C5.62966 17.8626 5.62966 17.4511 5.8835 17.1972L11.0807 12L5.8835 6.80277C5.62966 6.54892 5.62966 6.13737 5.8835 5.88353Z" fill="#02383E"/>
        </svg>
      `;

      block.appendChild(removeBtn);

      removeBtn.addEventListener('click', (ev) => {
        ev.stopPropagation();

        item.classList.remove('selected');

        const real = item.querySelector('.nested-remove');
        if (real) real.remove();

        block.classList.remove('is-selected');

        syncNestedIDs();
        if (mode == "crosselling") updateCrossSellingAddonsPreview();
        popup.setAttribute('aria-hidden', 'true');
        popup.classList.remove('is-open');
        document.body.classList.remove('no-scroll');
      });
    }

    const selectBtn = block.querySelector('.wim-nested-detail-select');

    selectBtn.addEventListener('click', () => {

      wrapper.querySelectorAll(selectors.item + ".selected")
        .forEach(s => {
          s.classList.remove('selected');
          const btn = s.querySelector('.nested-remove');
          if (btn) btn.remove();
        });

      item.classList.add('selected');

      if (!item.querySelector('.nested-remove')) {
        const realRemove = document.createElement('button');
        realRemove.type = 'button';
        realRemove.className = 'nested-remove';

        realRemove.innerHTML = `
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M5.8835 5.88353C6.13734 5.62969 6.54889 5.62969 6.80273 5.88353L12 11.0808L17.1972 5.88353C17.451 5.62969 17.8626 5.62969 18.1164 5.88353C18.3703 6.13737 18.3703 6.54892 18.1164 6.80277L12.9192 12L18.1164 17.1972C18.3703 17.4511 18.3703 17.8626 18.1164 18.1165C17.8626 18.3703 17.451 18.3703 17.1972 18.1165L12 12.9192L6.80273 18.1165C6.54889 18.3703 6.13734 18.3703 5.8835 18.1165C5.62966 17.8626 5.62966 17.4511 5.8835 17.1972L11.0807 12L5.8835 6.80277C5.62966 6.54892 5.62966 6.13737 5.8835 5.88353Z" fill="#02383E"/>
          </svg>
        `;

        item.appendChild(realRemove);

        realRemove.addEventListener('click', (ev) => {
          ev.stopPropagation();
          item.classList.remove('selected');
          realRemove.remove();
          syncNestedIDs();
          if (mode == "crosselling") updateCrossSellingAddonsPreview();
        });
      }
      syncNestedIDs();
      if (mode == "crosselling") updateCrossSellingAddonsPreview();
      popup.setAttribute('aria-hidden', 'true');
      popup.classList.remove('is-open');
      document.body.classList.remove('no-scroll');
    });
  });


  popup.setAttribute('aria-hidden', 'false');
  popup.classList.add('is-open');
  document.body.classList.add('no-scroll');

  // cerrar popup
  const close = () => {
    popup.setAttribute('aria-hidden', 'true');
    popup.classList.remove('is-open');
    document.body.classList.remove('no-scroll');
  };

  overlay.addEventListener('click', close);
  closeBtn.addEventListener('click', close);
}


function preloadCrossellingImages() {
  const imgs = document.querySelectorAll(
    '.wim-nested-img-container img, .wim-crosselling-img-container img'
  );

  imgs.forEach(img => {
    const src = img?.src;
    if (!src) return;
    let cleanSrc = src.replace(/([&?])width=\d+/g, '');

    cleanSrc += cleanSrc.includes('?') ? '&width=500' : '?width=500';

    const loader = new Image();
    loader.src = cleanSrc;
  });
}

if ("requestIdleCallback" in window) {
  requestIdleCallback((deadline) => {
    
    if (deadline.timeRemaining() > 0) {
      preloadCrossellingImages();
    } else {
      setTimeout(preloadCrossellingImages, 50);
    }

  }, { timeout: 500 });

} else {
  setTimeout(preloadCrossellingImages, 200);
}
